<template>
    <div class="wrapper">
                                    <div class="container">
                                        <div
                                            class="row service-box ApRow has-bg bg-boxed"
                                            style="background: no-repeat"
                                            data-bg_data=" no-repeat"
                                        >
                                            <div
                                                class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 col-sp-12 ApColumn"
                                            >
                                                <div
                                                    class="block service-item ApRawHtml"
                                                >
                                                    <div class="icon">
                                                        <i
                                                            class="fal fa-truck"
                                                        ></i>
                                                    </div>
                                                    <div class="content">
                                                        <span class="title"
                                                            >fast delivery</span
                                                        >
                                                        <p>
                                                            For all orders over
                                                            BTD 120/-
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 col-sp-12 ApColumn"
                                            >
                                                <div
                                                    class="block service-item ApRawHtml"
                                                >
                                                    <div class="icon">
                                                        <i
                                                            class="fal fa-credit-card"
                                                        ></i>
                                                    </div>
                                                    <div class="content">
                                                        <span class="title"
                                                            >safe Payments</span
                                                        >
                                                        <p>
                                                            100% secure payment
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 col-sp-12 ApColumn"
                                            >
                                                <div
                                                    class="block service-item ApRawHtml"
                                                >
                                                    <div class="icon">
                                                        <i
                                                            class="fal fa-gift-card"
                                                        ></i>
                                                    </div>
                                                    <div class="content">
                                                        <span class="title"
                                                            >Discount
                                                            Coupons</span
                                                        >
                                                        <p>
                                                            Enjoy Huge
                                                            Promotions
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 col-sp-12 ApColumn"
                                            >
                                                <div
                                                    class="block service-item ApRawHtml"
                                                >
                                                    <div class="icon">
                                                        <i
                                                            class="fal fa-comments-alt"
                                                        ></i>
                                                    </div>
                                                    <div class="content">
                                                        <span class="title"
                                                            >Quality
                                                            Support</span
                                                        >
                                                        <p>
                                                            Dedicated 24/7
                                                            support
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
</template>